import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withLocale } from 'core/hocs';

import { IconTime } from 'components/icons/icon-time/icon-time';
import { toCurrentTimeFormat } from 'helpers/date';

class CurrentTimeUI extends Component {
  static propTypes = {
    locale: PropTypes.string.isRequired,
  };

  intervalId;

  state = {
    ts: null,
  };

  componentDidMount() {
    this.setState({ ts: Date.now() });

    this.intervalId = setInterval(() => {
      this.setState({ ts: Date.now() });
    }, 1000);
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  render() {
    const { locale } = this.props;
    const { ts } = this.state;

    return ts && (
      <div className="d-flex align-items-center">
        <IconTime />
        <span className="ml-1_5 text-small font-weight-bold">
          {toCurrentTimeFormat(ts, locale)}
        </span>
      </div>
    );
  }
}

export const CurrentTime = withLocale(CurrentTimeUI);
